export interface ComicChapter {
  id: string;
  title: string;
  number: number;
  updatedAt: string;
}

export interface Comic {
  id: string;
  title: string;
  author: string;
  coverImage: string;
  description: string;
  category: string;
  tags: string[];
  status: '连载中' | '已完结';
  rating: number;
  views: number;
  favorites: number;
  updatedAt: string;
  chapters: ComicChapter[];
  totalChapters: number;
}

export const categories: { slug: string; name: string; icon: string }[] = [
  { slug: 'all', name: '全部', icon: 'ri-apps-2-line' },
  { slug: 'romance', name: '恋爱', icon: 'ri-heart-line' },
  { slug: 'fantasy', name: '奇幻', icon: 'ri-magic-line' },
  { slug: 'action', name: '热血', icon: 'ri-fire-line' },
  { slug: 'comedy', name: '搞笑', icon: 'ri-emotion-laugh-line' },
  { slug: 'drama', name: '剧情', icon: 'ri-film-line' },
  { slug: 'thriller', name: '悬疑', icon: 'ri-search-eye-line' },
  { slug: 'daily', name: '日常', icon: 'ri-sun-line' },
  { slug: 'historical', name: '古风', icon: 'ri-ancient-gate-line' },
  { slug: 'bl', name: 'BL', icon: 'ri-user-heart-line' },
];

export const comics: Comic[] = [
  {
    id: 'comic-1',
    title: '绝世王妃',
    author: '金秀妍',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20style%20romance%20cover%20featuring%20a%20beautiful%20princess%20in%20elegant%20traditional%20hanbok%20dress%20with%20flowers%2C%20soft%20pastel%20colors%2C%20romantic%20atmosphere%2C%20manhwa%20art%20style%2C%20clean%20simple%20background%2C%20digital%20illustration&width=600&height=800&seq=comic-cover-01&orientation=portrait',
    description: '一场意外穿越，现代女医生苏婉成为了古代王府不受宠的庶女。面对复杂的宫廷争斗和冷酷王爷的刁难，她凭借现代医学知识在古代大放异彩，也渐渐融化了王爷冰冷的心。然而当一切似乎走向美好时，一个惊天秘密浮出水面……',
    category: 'romance',
    tags: ['恋爱', '穿越', '古风', '甜宠'],
    status: '连载中',
    rating: 9.6,
    views: 1280000,
    favorites: 85000,
    updatedAt: '2026-08-04',
    totalChapters: 86,
    chapters: Array.from({ length: 86 }, (_, i) => ({
      id: `ch-1-${i + 1}`,
      title: `第${i + 1}话`,
      number: i + 1,
      updatedAt: `2026-${String(Math.max(1, 8 - Math.floor(i / 4))).padStart(2, '0')}-${String(Math.max(1, 30 - i)).padStart(2, '0')}`,
    })),
  },
  {
    id: 'comic-2',
    title: '暗夜君主',
    author: '李正勋',
    coverImage: 'https://readdy.ai/api/search-image?query=Dark%20fantasy%20Korean%20webtoon%20cover%20with%20a%20mysterious%20man%20in%20black%20cloak%20holding%20a%20sword%2C%20gothic%20castle%20background%2C%20dramatic%20lighting%20with%20red%20accents%2C%20intense%20manhwa%20art%20style%2C%20clean%20composition&width=600&height=800&seq=comic-cover-02&orientation=portrait',
    description: '千年前被封印的黑暗之主意外苏醒，却发现世界早已面目全非。曾经的手下全部消失，力量也大不如前。为了恢复实力，他伪装成普通高中生潜入人间，却意外卷入了一场关乎世界存亡的阴谋之中。',
    category: 'fantasy',
    tags: ['奇幻', '战斗', '转生', '热血'],
    status: '连载中',
    rating: 9.4,
    views: 980000,
    favorites: 72000,
    updatedAt: '2026-08-03',
    totalChapters: 64,
    chapters: Array.from({ length: 64 }, (_, i) => ({
      id: `ch-2-${i + 1}`,
      title: `第${i + 1}话`,
      number: i + 1,
      updatedAt: `2026-${String(Math.max(1, 8 - Math.floor(i / 3))).padStart(2, '0')}-${String(Math.max(1, 28 - i)).padStart(2, '0')}`,
    })),
  },
  {
    id: 'comic-3',
    title: '办公室密恋',
    author: '朴美英',
    coverImage: 'https://readdy.ai/api/search-image?query=Modern%20romance%20Korean%20webtoon%20cover%20showing%20a%20handsome%20man%20in%20business%20suit%20and%20a%20beautiful%20woman%20in%20office%20attire%2C%20romantic%20tension%2C%20city%20skyline%20background%2C%20soft%20warm%20lighting%2C%20manhwa%20style%20digital%20art&width=600&height=800&seq=comic-cover-03&orientation=portrait',
    description: '职场新人林小夏第一天上班就遇到了传说中的冷面上司顾北辰。工作上被他各种刁难，生活中却阴差阳错成为了邻居。朝夕相处中，她发现这个冷面上司其实有着不为人知的温柔一面。办公室里的秘密恋情，就此展开......',
    category: 'romance',
    tags: ['恋爱', '职场', '甜宠', '现代'],
    status: '已完结',
    rating: 9.5,
    views: 1560000,
    favorites: 95000,
    updatedAt: '2026-07-28',
    totalChapters: 120,
    chapters: Array.from({ length: 120 }, (_, i) => ({
      id: `ch-3-${i + 1}`,
      title: `第${i + 1}话`,
      number: i + 1,
      updatedAt: `2026-${String(Math.max(1, 7 - Math.floor(i / 5))).padStart(2, '0')}-${String(Math.max(1, 31 - i)).padStart(2, '0')}`,
    })),
  },
  {
    id: 'comic-4',
    title: '剑圣重生',
    author: '姜泰浩',
    coverImage: 'https://readdy.ai/api/search-image?query=Action%20Korean%20webtoon%20cover%20featuring%20a%20warrior%20with%20glowing%20sword%20in%20dynamic%20pose%2C%20martial%20arts%20theme%2C%20dramatic%20energy%20effects%2C%20oriental%20fantasy%20style%2C%20powerful%20atmosphere%2C%20manhwa%20digital%20illustration&width=600&height=800&seq=comic-cover-04&orientation=portrait',
    description: '一代剑圣在飞升之际被挚友背叛，陨落重生回到三十年前。带着前世的记忆和剑法，他誓要改写命运，保护他所珍视的一切。这一次，他不会再相信任何人，也不会再让悲剧重演！',
    category: 'action',
    tags: ['热血', '重生', '战斗', '武侠'],
    status: '连载中',
    rating: 9.3,
    views: 1120000,
    favorites: 78000,
    updatedAt: '2026-08-05',
    totalChapters: 72,
    chapters: Array.from({ length: 72 }, (_, i) => ({
      id: `ch-4-${i + 1}`,
      title: `第${i + 1}话`,
      number: i + 1,
      updatedAt: `2026-${String(Math.max(1, 8 - Math.floor(i / 3))).padStart(2, '0')}-${String(Math.max(1, 29 - i)).padStart(2, '0')}`,
    })),
  },
  {
    id: 'comic-5',
    title: '校园怪谈社',
    author: '崔智慧',
    coverImage: 'https://readdy.ai/api/search-image?query=Thriller%20Korean%20webtoon%20cover%20with%20students%20in%20school%20uniform%20in%20a%20dark%20school%20corridor%2C%20mysterious%20shadow%20figure%2C%20eerie%20atmosphere%2C%20blue%20moonlight%20through%20windows%2C%20suspense%20manhwa%20art%20style&width=600&height=800&seq=comic-cover-05&orientation=portrait',
    description: '转学生韩志浩加入了一个奇怪的社团——怪谈研究社。他本以为这只是一个普通的兴趣社团，却发现社团成员们调查的每一个校园怪谈，都是真实发生过的恐怖事件。而下一个怪谈的目标，似乎就是他自己......',
    category: 'thriller',
    tags: ['悬疑', '校园', '恐怖', '推理'],
    status: '连载中',
    rating: 9.2,
    views: 850000,
    favorites: 62000,
    updatedAt: '2026-08-01',
    totalChapters: 45,
    chapters: Array.from({ length: 45 }, (_, i) => ({
      id: `ch-5-${i + 1}`,
      title: `第${i + 1}话`,
      number: i + 1,
      updatedAt: `2026-${String(Math.max(1, 8 - Math.floor(i / 2))).padStart(2, '0')}-${String(Math.max(1, 27 - i)).padStart(2, '0')}`,
    })),
  },
  {
    id: 'comic-6',
    title: '猫咪咖啡馆',
    author: '尹素熙',
    coverImage: 'https://readdy.ai/api/search-image?query=Cute%20slice%20of%20life%20Korean%20webtoon%20cover%20with%20a%20girl%20surrounded%20by%20adorable%20cats%20in%20a%20cozy%20cafe%20setting%2C%20warm%20pastel%20colors%2C%20healing%20atmosphere%2C%20soft%20lighting%2C%20manhwa%20illustration%20style&width=600&height=800&seq=comic-cover-06&orientation=portrait',
    description: '失业的设计师金多慧接手了奶奶留下的老旧咖啡馆。本想转手卖掉，却意外发现咖啡馆里住着一群会说话的猫咪。在猫咪们的帮助下，她重新装修咖啡馆，做出美味甜点，也找回了生活的热情与梦想。',
    category: 'daily',
    tags: ['日常', '治愈', '美食', '萌宠'],
    status: '连载中',
    rating: 9.1,
    views: 720000,
    favorites: 58000,
    updatedAt: '2026-08-02',
    totalChapters: 52,
    chapters: Array.from({ length: 52 }, (_, i) => ({
      id: `ch-6-${i + 1}`,
      title: `第${i + 1}话`,
      number: i + 1,
      updatedAt: `2026-${String(Math.max(1, 8 - Math.floor(i / 2))).padStart(2, '0')}-${String(Math.max(1, 26 - i)).padStart(2, '0')}`,
    })),
  },
  {
    id: 'comic-7',
    title: '搞笑一家人',
    author: '张东民',
    coverImage: 'https://readdy.ai/api/search-image?query=Comedy%20Korean%20webtoon%20cover%20showing%20a%20chaotic%20family%20scene%20with%20exaggerated%20funny%20expressions%2C%20bright%20vivid%20colors%2C%20humorous%20situation%2C%20family%20gathering%20at%20dinner%20table%2C%20manhwa%20cartoon%20style&width=600&height=800&seq=comic-cover-07&orientation=portrait',
    description: '这是一个关于张家四口人的爆笑日常。有爱唠叨的妈妈、懒散的爸爸、叛逆期的姐姐和调皮捣蛋的弟弟。每天都是一场闹剧，但在吵闹中却充满了温馨。笑到停不下来的家庭喜剧！',
    category: 'comedy',
    tags: ['搞笑', '家庭', '日常', '温馨'],
    status: '已完结',
    rating: 9.0,
    views: 1050000,
    favorites: 69000,
    updatedAt: '2026-06-15',
    totalChapters: 150,
    chapters: Array.from({ length: 150 }, (_, i) => ({
      id: `ch-7-${i + 1}`,
      title: `第${i + 1}话`,
      number: i + 1,
      updatedAt: `2026-${String(Math.max(1, 6 - Math.floor(i / 6))).padStart(2, '0')}-${String(Math.max(1, 30 - i)).padStart(2, '0')}`,
    })),
  },
  {
    id: 'comic-8',
    title: '大明宫词',
    author: '韩雪儿',
    coverImage: 'https://readdy.ai/api/search-image?query=Historical%20Korean%20webtoon%20cover%20with%20elegant%20woman%20in%20traditional%20hanbok%20in%20ancient%20palace%20garden%2C%20cherry%20blossoms%2C%20classical%20architecture%2C%20soft%20golden%20light%2C%20refined%20manhwa%20art%20style%2C%20romantic%20historical%20atmosphere&width=600&height=800&seq=comic-cover-08&orientation=portrait',
    description: '朝鲜时代，才女李华因一首诗被选入宫中成为世子的伴读。在宫中她遇到了温润如玉的世子和冷峻寡言的侍卫长。三人之间的情感纠葛，在宫廷权谋的背景下荡气回肠。一段跨越阶层的爱情，能否在乱世中开花结果？',
    category: 'historical',
    tags: ['古风', '宫斗', '恋爱', '历史'],
    status: '连载中',
    rating: 9.7,
    views: 1350000,
    favorites: 91000,
    updatedAt: '2026-08-05',
    totalChapters: 58,
    chapters: Array.from({ length: 58 }, (_, i) => ({
      id: `ch-8-${i + 1}`,
      title: `第${i + 1}话`,
      number: i + 1,
      updatedAt: `2026-${String(Math.max(1, 8 - Math.floor(i / 2))).padStart(2, '0')}-${String(Math.max(1, 28 - i)).padStart(2, '0')}`,
    })),
  },
  {
    id: 'comic-9',
    title: '星之恋语',
    author: '李瑞元',
    coverImage: 'https://readdy.ai/api/search-image?query=BL%20romance%20Korean%20webtoon%20cover%20with%20two%20handsome%20young%20men%20gazing%20at%20each%20other%20under%20starry%20night%20sky%2C%20gentle%20romantic%20mood%2C%20soft%20blue%20and%20purple%20tones%2C%20emotional%20manhwa%20art%20style&width=600&height=800&seq=comic-cover-09&orientation=portrait',
    description: '天文系学生尹星辰在一次观星活动中遇见了神秘的音乐系学长沈夜。两个孤独的灵魂在星空下相遇，一场关于音乐、星辰与爱情的治愈故事就此展开。当他们彼此靠近，才发现原来对方就是自己一直在寻找的那颗星。',
    category: 'bl',
    tags: ['BL', '校园', '治愈', '音乐'],
    status: '已完结',
    rating: 9.5,
    views: 890000,
    favorites: 76000,
    updatedAt: '2026-07-20',
    totalChapters: 80,
    chapters: Array.from({ length: 80 }, (_, i) => ({
      id: `ch-9-${i + 1}`,
      title: `第${i + 1}话`,
      number: i + 1,
      updatedAt: `2026-${String(Math.max(1, 7 - Math.floor(i / 3))).padStart(2, '0')}-${String(Math.max(1, 31 - i)).padStart(2, '0')}`,
    })),
  },
  {
    id: 'comic-10',
    title: '末日生存指南',
    author: '朴镇宇',
    coverImage: 'https://readdy.ai/api/search-image?query=Post%20apocalyptic%20Korean%20webtoon%20cover%20showing%20survivors%20in%20destroyed%20cityscape%2C%20dramatic%20orange%20sky%2C%20ruined%20buildings%2C%20intense%20action%20pose%2C%20gritty%20manhwa%20art%20style%2C%20survival%20theme&width=600&height=800&seq=comic-cover-10&orientation=portrait',
    description: '一场突如其来的丧尸病毒席卷全球。普通上班族金泰浩在末日中觉醒了异能，带领幸存者们在这个残酷的新世界中挣扎求生。但最大的敌人，往往不是那些丧尸，而是人心......',
    category: 'action',
    tags: ['热血', '末日', '异能', '生存'],
    status: '连载中',
    rating: 9.4,
    views: 1420000,
    favorites: 88000,
    updatedAt: '2026-08-04',
    totalChapters: 96,
    chapters: Array.from({ length: 96 }, (_, i) => ({
      id: `ch-10-${i + 1}`,
      title: `第${i + 1}话`,
      number: i + 1,
      updatedAt: `2026-${String(Math.max(1, 8 - Math.floor(i / 4))).padStart(2, '0')}-${String(Math.max(1, 30 - i)).padStart(2, '0')}`,
    })),
  },
  {
    id: 'comic-11',
    title: '恋爱法则',
    author: '宋智恩',
    coverImage: 'https://readdy.ai/api/search-image?query=Youth%20romance%20Korean%20webtoon%20cover%20with%20young%20couple%20holding%20hands%20on%20campus%2C%20cherry%20blossom%20trees%2C%20spring%20atmosphere%2C%20bright%20pastel%20colors%2C%20sweet%20manhwa%20illustration%20style&width=600&height=800&seq=comic-cover-11&orientation=portrait',
    description: '母胎单身的学霸林月制定了一套严格的恋爱法则来寻找真命天子。然而当她遇到完全不按套路出牌的校草程朗时，所有法则全部失效。这位看似完美的校草，其实是个恋爱白痴？两个恋爱菜鸟的甜蜜碰撞正式开始！',
    category: 'comedy',
    tags: ['搞笑', '恋爱', '校园', '甜宠'],
    status: '连载中',
    rating: 9.2,
    views: 760000,
    favorites: 52000,
    updatedAt: '2026-08-03',
    totalChapters: 38,
    chapters: Array.from({ length: 38 }, (_, i) => ({
      id: `ch-11-${i + 1}`,
      title: `第${i + 1}话`,
      number: i + 1,
      updatedAt: `2026-${String(Math.max(1, 8 - Math.floor(i / 2))).padStart(2, '0')}-${String(Math.max(1, 25 - i)).padStart(2, '0')}`,
    })),
  },
  {
    id: 'comic-12',
    title: '灵异侦探所',
    author: '权相佑',
    coverImage: 'https://readdy.ai/api/search-image?query=Mystery%20Korean%20webtoon%20cover%20with%20detective%20holding%20magnifying%20glass%20in%20dark%20alley%2C%20supernatural%20elements%2C%20noir%20atmosphere%2C%20foggy%20street%2C%20intriguing%20manhwa%20art%20style&width=600&height=800&seq=comic-cover-12&orientation=portrait',
    description: '能看到鬼魂的私家侦探韩哲浩开了一家特殊的侦探所，专门解决和灵异事件有关的委托。某天，一个看似普通的失踪案件将他和一个神秘组织联系在了一起。真相远比想象中更加黑暗......',
    category: 'thriller',
    tags: ['悬疑', '灵异', '推理', '都市'],
    status: '连载中',
    rating: 9.3,
    views: 670000,
    favorites: 48000,
    updatedAt: '2026-07-30',
    totalChapters: 42,
    chapters: Array.from({ length: 42 }, (_, i) => ({
      id: `ch-12-${i + 1}`,
      title: `第${i + 1}话`,
      number: i + 1,
      updatedAt: `2026-${String(Math.max(1, 7 - Math.floor(i / 2))).padStart(2, '0')}-${String(Math.max(1, 28 - i)).padStart(2, '0')}`,
    })),
  },
];

export const featuredComicIds = ['comic-1', 'comic-8', 'comic-10', 'comic-4', 'comic-2'];

export const hotComicIds = ['comic-3', 'comic-8', 'comic-1', 'comic-10', 'comic-2', 'comic-5', 'comic-4', 'comic-7'];

export const newComicIds = ['comic-4', 'comic-8', 'comic-1', 'comic-2', 'comic-10', 'comic-11'];